
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.889 4.667H3.111a1.556 1.556 0 00-1.555 1.555v15.556a1.555 1.555 0 001.555 1.555h11.667l.443-.544.724-.887-.07-.124H3.11V6.222H24.89v6.658c.59.382 1.116.858 1.556 1.408V6.222a1.555 1.555 0 00-1.556-1.555z"}}),_c('path',{attrs:{"d":"M5.444 9.333h13.223v1.245H5.444V9.333zM5.444 12.444H14v1.245H5.444v-1.245zM5.444 17.889h7.778v1.244H5.444V17.89zM21.358 13.401a4.947 4.947 0 00-3.422 8.556l-1.51 1.843.7 2.808 2.848-3.47a4.87 4.87 0 002.76 0l2.847 3.47.7-2.808-1.508-1.843A4.947 4.947 0 0021.35 13.4h.008zm0 8.307a3.352 3.352 0 113.399-3.352 3.383 3.383 0 01-3.399 3.352z"}})])
          )
        }
      }
    